const ThemeConstants = {
  htmlFontSize: 16,
  fontFamily: 'IRANYekanXFaNum, arial',
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  fontWeightMediumBold: 800,
  fontWeightExtraBold: 900,
};

export default ThemeConstants;
